import React from 'react';
import { HashGenerator } from '../components/hash-generator/HashGenerator';

const HashGeneratorPage: React.FC = () => {
  return <HashGenerator />;
};

export default HashGeneratorPage;
